<template>
  <div class="navbar" :class="{ 'scrolled': isScrolled }">
    <div class="navbar-top">
      <div class="page-container">
        <div class="left-section">
          <Logo :to="$lp('/')"/>
        </div>
        <div class="right-section">
          <div class="action-buttons">
            <a href="#" class="language-switcher" @click.prevent="switchLocale">{{ isEn ? '中' : 'EN' }}</a>
            <el-input
                class="search-input"
                :placeholder="$t('nav.search')"
                v-model="searchKeyword"
                @keyup.enter="handleSearch"
            >
              <template #prefix>
                <el-icon>
                  <Search/>
                </el-icon>
              </template>
            </el-input>
            <el-button type="primary" size="small" @click="handleLoginClick">{{ $t('nav.admin') }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="navbar-main">
      <div class="page-container main-container">
        <el-menu
            :default-active="activeIndex"
            class="main-menu"
            mode="horizontal"
            background-color="#163C7D"
            text-color="#fff"
            active-text-color="#fff"
            @select="handleSelect"
            :ellipsis="false"
        >
          <el-menu-item :index="$lp('/')">{{ $t('common.home') }}</el-menu-item>
          <el-sub-menu :index="$lp('/about')">
            <template #title>{{ $t('nav.about') }}</template>
            <el-menu-item :index="$lp('/about')">{{ $t('nav.profile') }}</el-menu-item>
            <el-menu-item :index="$lp('/about/history')">{{ $t('nav.history') }}</el-menu-item>
<!--            <el-menu-item :index="$lp('/about/team')">管理团队</el-menu-item>-->
<!--            <el-menu-item :index="$lp('/about/organization')">组织架构</el-menu-item>-->
          </el-sub-menu>
          <el-sub-menu :index="$lp('/news')">
            <template #title>{{ $t('nav.news') }}</template>
            <el-menu-item :index="$lp('/news')">{{ $t('nav.newsList') }}</el-menu-item>
<!--            <el-menu-item :index="$lp('/news/media')">媒体报道</el-menu-item>-->
<!--            <el-menu-item :index="$lp('/news/video')">视频中心</el-menu-item>-->
          </el-sub-menu>
          <el-sub-menu :index="$lp('/boxs')">
            <template #title>{{ $t('nav.business') }}</template>
            <el-menu-item :index="$lp('/boxs')">{{ $t('nav.businessOverview') }}</el-menu-item>
            <el-menu-item :index="$lp('/boxs/services')">{{ $t('nav.services') }}</el-menu-item>
            <el-menu-item :index="$lp('/boxs/projects')">{{ $t('nav.projects') }}</el-menu-item>
          </el-sub-menu>
          <el-sub-menu :index="$lp('/product')">
            <template #title>{{ $t('nav.culture') }}</template>
<!--            <el-menu-item :index="$lp('/product')">核心价值观</el-menu-item>-->
            <el-menu-item :index="$lp('/product/social')">{{ $t('nav.socialResp') }}</el-menu-item>
            <el-menu-item :index="$lp('/product/innovation')">{{ $t('nav.innovation') }}</el-menu-item>
          </el-sub-menu>
          <el-menu-item :index="$lp('/recruits')">{{ $t('nav.recruits') }}</el-menu-item>
          <el-menu-item :index="$lp('/touch')">{{ $t('nav.touch') }}</el-menu-item>
        </el-menu>
      </div>
    </div>
    <!-- 移动端菜单 -->
    <div class="mobile-navbar">
      <div class="mobile-navbar-top">
        <div class="mobile-logo">
          <Logo :to="$lp('/')"/>
        </div>
        <div class="mobile-actions">
          <a href="#" class="lang-link" @click.prevent="switchLocale">{{ isEn ? '中' : 'EN' }}</a>
          <el-icon class="icon-btn" @click="showSearch = !showSearch">
            <Search/>
          </el-icon>
          <el-icon class="icon-btn" @click="toggleMobileMenu">
            <component :is="mobileMenuOpen ? Close : Menu"/>
          </el-icon>
        </div>
      </div>
      <div class="mobile-search" v-if="showSearch">
        <el-input
            :placeholder="$t('nav.search')"
            v-model="searchKeyword"
            @keyup.enter="handleSearch"
        >
          <template #prefix>
            <el-icon>
              <Search/>
            </el-icon>
          </template>
        </el-input>
      </div>
      <div class="mobile-menu" v-if="mobileMenuOpen">
        <el-collapse accordion>
          <el-collapse-item :title="$t('common.home')" name="home">
            <router-link :to="$lp('/')" @click="toggleMobileMenu">{{ $t('common.home') }}</router-link>
          </el-collapse-item>
          <el-collapse-item :title="$t('nav.about')" name="about">
            <router-link :to="$lp('/about')" @click="toggleMobileMenu">{{ $t('nav.profile') }}</router-link>
            <router-link :to="$lp('/about/history')" @click="toggleMobileMenu">{{ $t('nav.history') }}</router-link>
<!--            <router-link :to="$lp('/about/team')" @click="toggleMobileMenu">管理团队</router-link>-->
<!--            <router-link :to="$lp('/about/organization')" @click="toggleMobileMenu">组织架构</router-link>-->
          </el-collapse-item>
          <el-collapse-item :title="$t('nav.news')" name="news">
            <router-link :to="$lp('/news')" @click="toggleMobileMenu">{{ $t('nav.newsList') }}</router-link>
<!--            <router-link :to="$lp('/news/media')" @click="toggleMobileMenu">媒体报道</router-link>-->
<!--            <router-link :to="$lp('/news/video')" @click="toggleMobileMenu">视频中心</router-link>-->
          </el-collapse-item>
          <el-collapse-item :title="$t('nav.business')" name="business">
            <router-link :to="$lp('/boxs')" @click="toggleMobileMenu">{{ $t('nav.businessOverview') }}</router-link>
            <router-link :to="$lp('/boxs/services')" @click="toggleMobileMenu">{{ $t('nav.services') }}</router-link>
            <router-link :to="$lp('/boxs/projects')" @click="toggleMobileMenu">{{ $t('nav.projects') }}</router-link>
          </el-collapse-item>
          <el-collapse-item :title="$t('nav.culture')" name="culture">
<!--            <router-link :to="$lp('/product')" @click="toggleMobileMenu">核心价值观</router-link>-->
            <router-link :to="$lp('/product/social')" @click="toggleMobileMenu">{{ $t('nav.socialResp') }}</router-link>
            <router-link :to="$lp('/product/innovation')" @click="toggleMobileMenu">{{ $t('nav.innovation') }}</router-link>
          </el-collapse-item>
          <el-collapse-item :title="$t('nav.recruits')" name="jobs">
            <router-link :to="$lp('/recruits')" @click="toggleMobileMenu">{{ $t('nav.recruits') }}</router-link>
          </el-collapse-item>
          <el-collapse-item :title="$t('nav.touch')" name="contact">
            <router-link :to="$lp('/touch')" @click="toggleMobileMenu">{{ $t('nav.touch') }}</router-link>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import {useRoute, useRouter} from 'vue-router';
import {ref, computed, onMounted, onUnmounted, watch} from 'vue';
import {Search, Menu, Close} from '@element-plus/icons-vue';
import Logo from './Logo.vue';
import {LOCALE_ZH, LOCALE_EN} from '../locales';
import {localeOfPath, localePath, setStoredLocale} from '../utils/locale';

export default {
  name: 'Navbar',
  components: {
    Logo,
    Search,
    Menu,
    Close
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isScrolled = ref(false);
    const mobileMenuOpen = ref(false);
    const showSearch = ref(false);
    const searchKeyword = ref('');

    // 计算当前活动菜单
    // Element Plus 的 el-menu 仅在 default-active 与 :index 精确相等时高亮，
    // 因此把子路由折叠到父菜单项，确保 /recruits/jobs/:id 也能高亮"人才招聘"
    const activeIndex = computed(() => {
      const p = route.path;
      if (p.startsWith('/recruits')) return '/recruits';
      return p;
    });

    // 当前是否英文站（以 URL 为准）
    const isEn = computed(() => localeOfPath(route.path) === LOCALE_EN);

    // 语言切换：同路径互换中英文（保留 :id 与 query），并记住用户选择
    const switchLocale = () => {
      const target = isEn.value ? LOCALE_ZH : LOCALE_EN;
      setStoredLocale(target);
      router.push({
        path: localePath(route.path, target),
        query: route.query
      });
    };

    // 处理滚动事件
    const handleScroll = () => {
      if (typeof window !== 'undefined') {
        isScrolled.value = window.scrollY > 50;
      }
    };

    // 切换移动端菜单
    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value;
      if (mobileMenuOpen.value) {
        showSearch.value = false;
      }
    };

    // 搜索处理（跳转到当前语言下的搜索页）
    const handleSearch = () => {
      if (searchKeyword.value && searchKeyword.value.trim()) {
        router.push({
          path: localePath('/search', localeOfPath(route.path)),
          query: {keyword: searchKeyword.value}
        });
        searchKeyword.value = '';
        showSearch.value = false;
      }
    };

    // 菜单项点击
    const handleSelect = (index) => {
      if (index) {
        router.push({
          path: index
        });
      }
    };

    // 登录处理
    const handleLoginClick = () => {
      if (typeof window !== 'undefined') {
        window.location.href = "https://sys.jingtianxia.com:8080";
      }
    };

    // 路由变化时关闭移动菜单
    watch(() => route.path, () => {
      mobileMenuOpen.value = false;
      showSearch.value = false;
    });

    onMounted(() => {
      if (typeof window !== 'undefined') {
        window.addEventListener('scroll', handleScroll);
        handleScroll();
      }
    });

    onUnmounted(() => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll);
      }
    });

    return {
      activeIndex,
      isEn,
      switchLocale,
      isScrolled,
      mobileMenuOpen,
      showSearch,
      searchKeyword,
      toggleMobileMenu,
      handleSearch,
      handleSelect,
      handleLoginClick,
      Search,
      Menu,
      Close
    };
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: all 0.3s ease;

  .navbar-top {
    background-color: #fff;
    padding: 15px 0;

    .page-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .left-section {
      display: flex;
      align-items: center;
    }

    .right-section {
      display: flex;
      align-items: center;

      .action-buttons {
        display: flex;
        align-items: center;
        gap: 15px;

        .language-switcher {
          color: #333;
          font-weight: 500;
          text-decoration: none;

          &:hover {
            color: var(--primary-color);
          }
        }

        .search-input {
          width: 180px;
        }
      }
    }
  }

  .navbar-main {
    background-color: #163C7D;

    .main-container {
      display: flex;
      justify-content: space-between;
    }

    .main-menu {
      border-bottom: none;
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    :deep(.el-menu-item) {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: 500;

      &.is-active {
        background-color: #072a68 !important;
        border-bottom: 3px solid #fff;
      }

      &:hover {
        background-color: #072a68 !important;
      }
    }

    :deep(.el-sub-menu__title) {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: 500;

      &:hover {
        background-color: #072a68 !important;
      }
    }

    :deep(.el-sub-menu__icon-arrow) {
      color: #fff;
    }
  }

  .mobile-navbar {
    display: none;
    background-color: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .mobile-navbar-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
    }

    .mobile-actions {
      display: flex;
      align-items: center;
      gap: 20px;

      .lang-link {
        color: #333;
        font-weight: 500;
        font-size: 14px;
        text-decoration: none;

        &:hover {
          color: var(--primary-color);
        }
      }

      .icon-btn {
        font-size: 24px;
        cursor: pointer;
        color: #333;
      }
    }

    .mobile-search {
      padding: 0 15px 15px;
    }

    .mobile-menu {
      background-color: #f5f5f5;
    }

    :deep(.el-collapse-item__header) {
      padding: 0 15px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }

    :deep(.el-collapse-item__content) {
      padding: 0;

      a {
        display: block;
        padding: 12px 30px;
        color: #666;
        text-decoration: none;
        border-bottom: 1px solid #eee;

        &:hover {
          color: var(--primary-color);
          background-color: #f0f0f0;
        }
      }
    }
  }
}

// 响应式调整
@media (max-width: 992px) {
  .navbar {
    .navbar-top, .navbar-main {
      display: none;
    }

    .mobile-navbar {
      display: block;
    }
  }
}
</style>